import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import NodeFilterField from './NodeFilterField';
import { ALL_VALUE } from './nodeFilterUtils';

/**
 * Один динамический фильтр из каталога узлов.
 * Если выбранный код исчез из каталога (загрузили новый пакет) — сбрасываем на «Все».
 */
const NodeFilterSelect = ({ filter, value, onChange }) => {
  const options = filter.options ?? [];
  const known = value === ALL_VALUE || options.some((option) => option.code === value);
  const effectiveValue = known ? value ?? ALL_VALUE : ALL_VALUE;

  // У чек-листа фильтр отбирает звонки с проваленным пунктом (оценка <= 0.5), а не все,
  // где пункт оценивался. Раньше это уточнение стояло в самой подписи, и заголовок
  // разрастался до «Магазин: адрес и маршрутизация — провален пункт». Теперь чек-листы
  // лежат в подгруппе «Провалы по чек-листам», где это следует из её названия,
  // а уточнение осталось в подсказке.
  const isChecklist = filter.kind === 'checklist_results';
  const hint = isChecklist ? `${filter.label}: отбираются звонки с проваленным пунктом` : undefined;

  return (
    <NodeFilterField label={filter.label} hint={hint}>
      <Select trackId="nodes.filters.select" value={effectiveValue} onValueChange={onChange}>
        <SelectTrigger className="h-8 w-full text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_VALUE}>Все</SelectItem>
          {options.map((option) => (
            <SelectItem key={option.code} value={option.code}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </NodeFilterField>
  );
};

export default NodeFilterSelect;
